export enum LocalStorageItem {
	JWT = "token",
	AUTH_STATE = "auth_state",
	LAST_LOGIN = "last_login",
	ALREADY_READ_MESSAGES = "already_read_messages",
	USERS_ACCEPTED_T_AND_C = "users_accepted_terms_and_conds",
	EXTERNAL_PLAN_INFO = "external_plan_info"
}
